import withClient from './WithClient';

export default withClient;
